var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_graph",
    "data-name": "vuesax/outline/graph",
    transform: "translate(-300 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph",
    transform: "translate(300 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.907,24.5H8.438C2.835,24.5,0,21.324,0,15.046V8.589c0-2.3.27-5.58,2.655-7.38,2-1.485,4.882-1.6,9.135-.36A17.787,17.787,0,0,1,23.648,12.706c1.237,4.23,1.125,7.133-.36,9.113C21.488,24.226,18.2,24.5,15.907,24.5ZM6.817,3.369a3.491,3.491,0,0,0-2.115.54c-.878.653-1.3,2.183-1.3,4.68v6.48c0,5.04,1.935,6.075,5.063,6.075h7.47c2.475,0,4-.427,4.68-1.305.788-1.035.72-3.105-.158-6.143A14.566,14.566,0,0,0,10.89,4.134,14.287,14.287,0,0,0,6.817,3.369Z",
    transform: "translate(25.313 4.191)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M22.1,43.863A22.14,22.14,0,0,1,17.686.033a1.711,1.711,0,0,1,2,1.3,1.711,1.711,0,0,1-1.305,2A18.774,18.774,0,1,0,40.568,25.435a1.686,1.686,0,1,1,3.307.653A22.166,22.166,0,0,1,22.1,43.863Z",
    transform: "translate(2.812 7.325)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H54V54H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircle);
export default __webpack_public_path__ + "static/media/half-circle.71dbb6b9a80f7c7583ae60086f48ebc9.svg";
export { ForwardRef as ReactComponent };